import { useEffect, useState } from "react";
import VendorUsers from "./VendorUsers";
import VendorProfiles from "./VendorProfiles";
import { Button, InputGroup, Form } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function VendorDetails(props) {
  const vendors = props;
  const axiosPrivate = useAxiosPrivate();
  const controller = new AbortController();

  const [health, setHealth] = useState();

  const vendorUpdate = async (vendorId, payload) => {
    try {
      const response = await axiosPrivate.patch(
        `updateVendor?vendorId=${vendorId}`,
        payload,
        {
          signal: controller.signal,
        }
      );
      console.log(response.data);
    } catch (err) {
      console.error(err);
    }
  };



  const getVendorHealth = async () => {
    try {
      const response = await axiosPrivate.get(`vendor/health/?id=${vendors.vendor.id}`, {});
      setHealth(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getVendorHealth();
  }, []);


  const [showBetweenError, setShowBetweenError] = useState(false);
  const [showSuccessText, setShowSuccessText] = useState(false);
  const [showErrorText, setShowErrorText] = useState(false);
  const [users, setUsers] = useState([]);
  const [
    secondsBetweenInvitationsToSameEmail,
    setSecondsBetweenInvitationsToSameEmail,
  ] = useState(vendors.vendor.seconds_between_invitations_to_same_email);
  const [termsOfUseVisible, setTermsOfUseVisible] = useState(
    vendors.vendor.terms_of_use_visible
  );
  const [anonymousReviewing, setAnonymousReviewing] = useState(
    vendors.vendor.anonymous_reviewing
  );
  const [reviewFormAutoRefreshSeconds, setReviewAutoRefreshSeconds] = useState(
    vendors.vendor.review_form_auto_refresh_seconds
  );
  const [warningEnabled, setWarningEnabled] = useState(
    vendors.vendor.settings?.warningEnabled || false
  );
  const [warningPeriodDays, setWarningPeriodDays] = useState(
    vendors.vendor.settings?.warningPeriodDays || 1
  );
  const [autoApproveEnabled, setAutoApproveEnabled] = useState(
    vendors.vendor.settings?.autoApproveEnabled || false
  );


  const updateSecondsBetween = (e) => {
    let value = +e.target.value;
    if (isNaN(value) || !value) {
      setShowBetweenError(true);
      setSecondsBetweenInvitationsToSameEmail(e.target.value);
    } else {
      setShowBetweenError(false);
      setSecondsBetweenInvitationsToSameEmail(value);
    }
  };

  const updateVendor = () => {
    let payload = {
      secondsBetweenInvitationsToSameEmail:
        +secondsBetweenInvitationsToSameEmail,
      termsOfUseVisible: termsOfUseVisible,
      anonymousReviewing: anonymousReviewing,
      reviewFormAutoRefreshSeconds: +reviewFormAutoRefreshSeconds || null,
      settings: {
        warningEnabled: warningEnabled,
        warningPeriodDays: +warningPeriodDays,
        autoApproveEnabled: autoApproveEnabled,
      }
    };
    if (showBetweenError) return;
    vendorUpdate(vendors.vendor.id, payload);
  };

  return (
    <div>
      <div className="row prcVendorDetails">
        <div className="col-md-6">
          <div className="prcVendorUsers">
            <VendorUsers
              vendorId={vendors.vendor.id}
              languages={vendors.vendor.languages}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="prcVendorProfiles">
            <VendorProfiles vendorId={vendors.vendor.id} />
          </div>
        </div>

        <div className="row prcVendorDetails">
          <div className="col-md-6">
            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon1">
                Interval med povabili (sec)
              </InputGroup.Text>
              <Form.Control
                aria-label="Cas med povabili (sec)"
                aria-describedby="basic-addon1"
                placeholder="Cas med povabili (sec)"
                value={secondsBetweenInvitationsToSameEmail}
                onChange={(e) => updateSecondsBetween(e)}
              />
            </InputGroup>

            {showBetweenError && (
              <span style={{ color: "red" }}>Polje je obvezno</span>
            )}

            <InputGroup className="mb-3">
              <InputGroup.Checkbox
                aria-label="Vidni pogoji poslovanja"
                checked={termsOfUseVisible}
                onChange={(e) => setTermsOfUseVisible(e.target.checked)}
              />
              <InputGroup.Text id="basic-addon1">
                Vidni pogoji poslovanja
              </InputGroup.Text>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Checkbox
                aria-label="Anonimno ocenjevanje"
                checked={anonymousReviewing}
                onChange={(e) => setAnonymousReviewing(e.target.checked)}
              />
              <InputGroup.Text id="basic-addon1">
                Anonimno ocenjevanje
              </InputGroup.Text>
            </InputGroup>

            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon1">
                Osvezevanje ocenjevanja (sec)
              </InputGroup.Text>
              <Form.Control
                placeholder="Cas med povabili (sec)"
                aria-label="Cas med povabili (sec)"
                aria-describedby="basic-addon1"
                value={reviewFormAutoRefreshSeconds || ""}
                onChange={(e) => setReviewAutoRefreshSeconds(e.target.value)}
              />
            </InputGroup>

            <div style={{ marginTop: "20px" }}>
              <Button onClick={() => updateVendor()}>Osvezi</Button>
            </div>
            <div>
              {showSuccessText && <span>Podatki so bili posodobljeni</span>}
              {showErrorText && (
                <span style={{ color: "rec" }}>
                  Prislo je do napake pri posodabljanju
                </span>
              )}
            </div>

          </div>
          <div className="col-md-6">
            <div className="prcVendorProfiles">
              <div className="prcVendorDetailsTitleRow">
                <div className="col-sm-12">
                  <strong>STANJE VENDORJA (ID: {vendors.vendor.id})</strong>
                </div>
              </div>
              <div className="row mt-3 mb-4">
                <div className="col-md-12">
                  <InputGroup className="mb-2">
                    <InputGroup.Checkbox
                      aria-label="Preverjanje pošiljanja (vklopi opozorilo)"
                      checked={warningEnabled}
                      onChange={(e) => setWarningEnabled(e.target.checked)}
                    />
                    <InputGroup.Text id="basic-addon1">
                      Preverjanje pošiljanja (vklopi opozorilo)
                    </InputGroup.Text>
                  </InputGroup>

                  <InputGroup className="mb-2">
                    <InputGroup.Checkbox
                      aria-label="Avtomatsko potrjevanje ocen"
                      checked={autoApproveEnabled}
                      onChange={(e) => setAutoApproveEnabled(e.target.checked)}
                    />
                    <InputGroup.Text id="basic-addon2">
                      Avtomatsko potrjevanje ocen
                    </InputGroup.Text>
                  </InputGroup>

                  <InputGroup className="mb-2">
                    <InputGroup.Text id="basic-addon1">
                      Obdobje pošiljanja (dni)
                    </InputGroup.Text>
                    <Form.Control
                      placeholder="Obdobje pošiljanja (dni)"
                      aria-label="Obdobje pošiljanja (dni)"
                      aria-describedby="basic-addon1"
                      value={warningPeriodDays}
                      onChange={(e) => setWarningPeriodDays(e.target.value)}
                      type="number"
                      min="1"
                    />
                  </InputGroup>
                  <Button variant="secondary" size="sm" onClick={() => updateVendor()}>Shrani opozorilo</Button>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  {health && (
                    <div>
                      <div>Poslano v zadnjem dnevu: <strong>{health.invitations.invitations_last_day}</strong></div>
                      <div>Poslano v zadnjih 7 dneh: <strong>{health.invitations.invitations_last_week}</strong></div>
                      <div>Poslano v zadnjih 30 dneh: <strong>{health.invitations.invitations_last_month}</strong></div>
                      <div>Poslano v zadnjem letu: <strong>{health.invitations.invitations_last_year}</strong></div>
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                  {health && (
                    <div>
                      <div>Ocene v zadnjem dnevu: <strong>{health.reviews.reviews_last_day}</strong></div>
                      <div>Ocene v zadnjih 7 dneh: <strong>{health.reviews.reviews_last_week}</strong></div>
                      <div>Ocene v zadnjih 30 dneh: <strong>{health.reviews.reviews_last_month}</strong></div>
                      <div>Ocene v zadnjem letu: <strong>{health.reviews.reviews_last_year}</strong></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VendorDetails;
